<div class="card" *ngIf="showCard">
  <div class="card-header" style="border-bottom: none">
    <div
      class="card-title d-flex flex-row justify-content-between align-items-center"
    >
      <!-- Title: prefer drilldown title (clicked Product ID), else fallback -->
      <h5 style="margin: 0">
        {{
          title || (data?.title ? (productId ? productId + "-" : "") + data.title : "")
        }}
      </h5>

      <div class="d-flex align-items-center gap-3">
        <div class="info-box">
          <p style="margin: 0">10 - Highest | 1 - Lowest</p>
        </div>

        <!-- Save button (SFE only) -->
        <button
          *ngIf="data?.SetFutureExpectations"
          type="button"
          class="btn btn-primary"
          (click)="onSave()"
          style="padding: 4px 10px"
        >
          Save
        </button>

        <button
          *ngIf="data?.close"
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="onClose()"
          style="font-size: 1.2rem"
        ></button>
      </div>
    </div>
  </div>

  <div class="card-body">
    <div *ngIf="loading && !hasError" class="loader-container">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="50"
        strokeWidth="5"
        color="primary"
      ></mat-progress-spinner>
      <p>Loading data...</p>
    </div>

    <div *ngIf="!hasError && !loading">
      <div
        *ngIf="data.periodType === 'combined' && !data.hideSecondScoreBox"
        style="
          display: flex;
          justify-content: flex-end;
          font-weight: 500;
          color: #333;
          margin-right: 5%;
        "
      >
        <span style="font-weight: 600">{{ filters?.start_date }}</span
        >-
        <span style="font-weight: 600">{{ filters?.end_date }}</span>
      </div>

      <div class="custom-legend" *ngIf="data.editable">
        <div class="legend-item">
          <div
            class="color-circle"
            [style.background-color]="'#adacac90'"
          ></div>
          <span>Original values and cannot be edited</span>
        </div>
        <div class="legend-item">
          <div class="color-circle" [style.background-color]="'#ffff'"></div>
          <span>Values can be edited to see the position of the bubble</span>
        </div>
      </div>
      <div
        *ngIf="data?.SetFutureExpectations"
        class="d-flex align-items-center gap-2 mt-2"
      >
        <label style="margin: 0; font-weight: 500; font-size: 14px"
          >Product Portfolio:</label
        >
        <select
          class="form-select"
          style="width: 180px; height: 28px; padding: 2px 6px"
          [(ngModel)]="productPortfolio"
        >
          <option
            *ngFor="let opt of data?.portfolioOptions || portfolioOptions"
            [value]="opt"
          >
            {{ opt }}
          </option>
        </select>
      </div>
      <div
        style="overflow-y: auto; margin: 4px"
        [style.height]="data.height || '70vh'"
      >
        <ng-container *ngFor="let node of scoreTree">
          <ng-container
            *ngTemplateOutlet="
              renderPanel;
              context: { $implicit: node, level: 1 }
            "
          ></ng-container>
        </ng-container>

        <!-- Recursive render -->
        <ng-template #renderPanel let-node let-level="level">
          <mat-expansion-panel
            class="custom-panel level-{{ level }}"
            hideToggle
            [expanded]="node.children?.length > 0"
            (opened)="node.expanded = true"
            (closed)="node.expanded = false"
          >
            <mat-expansion-panel-header   [ngClass]="{
              'grey-out': data?.markUnchangedScores && node.score === node.simulatedScore
            }">
              <div class="panel-header">
                <mat-icon class="info-icon" *ngIf="level < 3">
                  subdirectory_arrow_right
                </mat-icon>
                <span class="title">{{ node.name }}</span>

                <!-- ===== SFE MODE ===== -->
                <ng-container
                  *ngIf="data?.SetFutureExpectations; else legacyInputs"
                >
                  <input
                    type="number"
                    [class.score-box2]="
                      node.name === 'Largest OEM' ||
                      node.name === 'Certification Config'
                    "
                    [class.score-box]="
                      node.name !== 'Largest OEM' &&
                      node.name !== 'Certification Config'
                    "
                    [value]="node.score"
                    [(ngModel)]="node.score"
                    (click)="$event.stopPropagation()"
                  />
                </ng-container>

                <ng-template #legacyInputs>
                  <input
                    type="text"
                    [class.score-box2]="
                      node.name === 'Largest OEM' ||
                      node.name === 'Certification Config'
                    "
                    [class.score-box]="
                      node.name !== 'Largest OEM' &&
                      node.name !== 'Certification Config'
                    "
                    disabled="true"
                    [value]="node.score"
                    [ngStyle]="
                      !data.editable && scores?.includes(node.name)
                        ? getScoreColor(node.score)
                        : { 'background-color': '#adacac90' }
                    "
                  />

                  <input
                    *ngIf="
                      (data.periodType === 'combined' && !data.hideSecondScoreBox) ||
                      (data.box2 &&
                        !data.hideSecondScoreBox &&
                        node.name !== 'Largest OEM' &&
                        node.name !== 'Certification Config')
                    "
                    class="score-box"
                    type="text"
                    [value]="node.simulatedScore"
                    disabled="true"
                    [ngStyle]="
                      !data.editable &&
                      scores?.includes(node.name) &&
                      !data.skipColorLevels?.includes(level)
                        ? getScoreColor(node.simulatedScore)
                        : { 'background-color': '#adacac90' }
                    "
                  />

                  <input
                    *ngIf="data.editable"
                    class="score-box"
                    type="number"
                    min="0.0"
                    step="any"
                    [attr.max]="scores?.includes(node.name) ? 100 : null"
                    (change)="validateScore($event, node)"
                    [value]="node.simulatedScore || node.score"
                    (click)="$event.stopPropagation()"
                    [disabled]="
                      (level < 3 && node.name != 'Strategic Importance') ||
                      node.name === 'Key Market' ||
                      node.name === 'Largest OEM' ||
                      node.name === 'Certification Config' ||
                      node.name === 'Product Cost % Difference'

                    "
                  />
                </ng-template>

                <!-- Tooltips -->
                <ng-container
                  *ngIf="
                    getTooltipTableData(node.name) as tooltipData;
                    else defaultTooltip
                  "
                >
                  <mat-icon
                    class="info-icon"
                    [mtxTooltip]="tooltipTpl"
                    mtxTooltipPosition="left"
                    matTooltipShowDelay="300"
                  >
                    help
                  </mat-icon>
                  <ng-template #tooltipTpl>
                    <app-tooltiptable
                      [tableData]="tooltipData"
                    ></app-tooltiptable>
                  </ng-template>
                </ng-container>

                <ng-template #defaultTooltip>
                  <ng-container
                    *ngIf="
                      node.name === 'Product Cost $/HP (Reactive Cost)';
                      else normalIcon
                    "
                  >
                    <a href="assets/product-cost.pdf" download>
                      <mat-icon
                        class="info-icon"
                        [matTooltip]="def ? getToolTip(node.name) : ''"
                        matTooltipPosition="above"
                        matTooltipShowDelay="300"
                        style="cursor: pointer"
                      >
                        help
                      </mat-icon>
                    </a>
                  </ng-container>
                  <ng-template #normalIcon>
                    <mat-icon
                      class="info-icon"
                      [matTooltip]="def ? getToolTip(node.name) : ''"
                      matTooltipPosition="above"
                      matTooltipShowDelay="300"
                    >
                      help
                    </mat-icon>
                  </ng-template>
                </ng-template>
              </div>
            </mat-expansion-panel-header>

            <div *ngIf="node.children?.length">
              <ng-container *ngFor="let child of node.children">
                <ng-container
                  *ngTemplateOutlet="
                    renderPanel;
                    context: { $implicit: child, level: level + 1 }
                  "
                ></ng-container>
              </ng-container>
            </div>
          </mat-expansion-panel>
        </ng-template>
      </div>
    </div>
    <app-data-error
      *ngIf="hasError"
      [message]="errorMessage"
      [height]="'66vh'"
    ></app-data-error>
  </div>
</div>
